import { AppBar, Box, Container, Grid, Typography } from '@mui/material';
import logo from './../assets/usuariosfinanciados.png';
import line from './../assets/line.png'; // Asegúrate de que esta ruta sea correcta

const styleFont = {
  fontSize: {
    xs: '0.6rem',
    md: '1.1rem'
  },
  color: '#ffffff'
};

export function FooterBar() {
  return (
    <Box sx={{ bgcolor: '#133385', bottom: 0, width: '100%', minHeight: '180px' }}>
      {/* Línea de colores en la parte superior */}
      <Box
        component="img"
        src={line}
        alt="Línea de colores"
        sx={{
          width: '100%',
          height: '9px', // Ajusta la altura según el diseño de la línea
          display: 'block',
        }}
      />
      
      <AppBar position="static" color="transparent" elevation={0} sx={{ bgcolor: 'transparent' }}>
        <Container maxWidth="xl">
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2} // Espaciado entre los elementos
            sx={{ mt: { xs: 1, md: 0 }, // Espacio superior en móviles
                minHeight: '180px' }}
          >
            {/* Texto */}
            <Grid item xs={12} md={9} textAlign={{ xs: 'center', md: 'left' }} sx={{ mb: { xs: 2, md: 0 } }}>
              <Typography sx={styleFont} variant="body2" gutterBottom>
                Banco Columbia S.A.. CUIT: 30-51763749-8. Sede social: Tte. Gral. Juan Domingo Perón 350 (C1038AAH), Ciudad Autónoma de Buenos Aires. Agente de Negociación y Agente de Liquidación y Compensación Propio inscripto ante la Comisión Nacional de Valores bajo el N° 138. Agente Institorio inscripto ante la Superintendencia de Seguros de la Nación bajo el N° 152.
              </Typography>
              <Typography sx={styleFont} variant="body2">
                &copy; 2024 - Banco Columbia. Todos los derechos reservados
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              display="flex"
              justifyContent={{ xs: 'center', md: 'flex-end' }}
              alignItems="center"
            >
              <Box
                component="img"
                src={logo}
                alt="Usuarios Financieros"
                sx={{
                  maxHeight: '120px',
                  width: 'auto',
                  mb: { xs: 1, md: 0 }, // Espacio inferior en móviles
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </AppBar>
    </Box>
  );
}
